import React, { useEffect } from "react";
import {
  Typography,
  Container,
  TextField,
  Button,
  Grid,
  Link,
} from "@mui/material";
import GradientBtn from "@ui/GradientBtn";
import HeaderSection from "@layout/comingSoon/HeaderSection";
import HeroSection from "@layout/comingSoon/HeroSection";
import KeyFeature from "@layout/comingSoon/KeyFeature";
//import Testimonials from "@layout/comingSoon/Testimonials";
import Testimonials from "@components/TestimonialSection";
import ReactGA from "react-ga4";
import PreLaunch from "@layout/comingSoon/PreLaunch";
import FineModels from "@layout/comingSoon/Models/FineModels";
import Gallery from "@layout/comingSoon/Gallery";
import Banner from "@layout/comingSoon/Banner";
import HowToWork from "@layout/comingSoon/HowToWork";

import HowItWorks from "@layout/home/HowItWorks";
import Presentation from "@layout/home/Presentation";
import PriceAndSell from "@layout/home/PriceAndPlans";
import FAQQuestions from "@components/faq/FAQQuestions";

import Hero from "@layout/comingSoon/Hero";
import CreateAndSell from "@layout/comingSoon/CreateAndSell";
import WhyChoose from "@layout/comingSoon/WhyChoose";
import CTA2 from "@layout/comingSoon/CTA2";
import FAQ from "./FAQ";

const ComingSoonSection = () => {
  useEffect(() => {
   console.log("PAGE VIEW",window.location.pathname)
   ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Coming Page" });
  }, [])

  return (
    <>
      <Hero/>
        <CreateAndSell /> {/* Features & Benefits */}
        <WhyChoose/>
        <FineModels/>
        <CTA2 />
        <Gallery />
        <Testimonials />
        {/* <HowItWorks /> */}
         {/* How it works */}
        {/* <Presentation /> */}
        {/* How it Video */}
        <PriceAndSell /> {/* Pricing & Plans */}
        <FAQ />
        {/* Click To Action */}
        {/* <NotableDrops /> */}
        {/* <BestSellers /> */}
        {/* <Browse /> */}
        {/* <Blog /> */}
      {/* <HeaderSection />
      <HeroSection />
      <KeyFeature />
      <FineModels />
      <HowToWork />

      <PreLaunch />

      <Testimonials />

      <Banner /> */}

    </>
  );
};

export default ComingSoonSection;
